import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { EndasureTooltipPopUPComponent } from 'src/app/customcomponents/endasure/endasure-tooltip-pop-up/endasure-tooltip-pop-up.component';
import { payloadEnda } from '../../sapSpartacus/model.model';

@Injectable({
  providedIn: 'root'
})
export class EndasureService {

  public defaultvistInfo = {
    firstName: '',
    lastName: '',
    eMail: '',
    valueDisclaimer: false
  };

  private defaultFleetInfo = {
    fleetSizeTractors: 1000,
    tractorTradeInCycle: 5,
    fleetSizeTrailers: 1000,
    trailerTradeInCycle: 10
  };

  private defaultreplacement = {
    replacementFleetCostPerActuator: 150.00,
    laborToInstallActuator: 65.00,
    totalCostPerFailedActuator: 215.00,
    numberOfActuatorsReplacedPerYear: 270
  };

  private defaultrecurrentProduct = {
    brandOfActuator: 'Haldex Gold Seal',
  };

  private defaultCsa = {
    roadsideCallRate: 500.00,
    annualRoadsideCallsToActuators: 20.00,
    roadsideCallRateCsaViolation: 2000.00,
    annualOutOfServiceCsaViolations: 2,
    fleetDowntimeRate:1200.00
  };

  private defaultPro = {
    estUpchargeForEndTractor: 145.00,
    estUpchargeForEndTrailer: 130.00
  };
  private popUpData=
  { FName: '', LName: '', emailId: '' };

  private defaultData = [
    {
        "standardUnit": 0,
        "standardFleet": 145,
        "sealedUnit": 145,
        "sealedFleet": 145000,
        "displayValue": "0.00_145_145.00_145,000"
    },
    {
        "standardUnit": 0,
        "standardFleet": 0,
        "sealedUnit": 130,
        "sealedFleet": 130000,
        "displayValue": "0.00_0_130.00_130,000"
    },
    {
        "standardUnit": 0,
        "standardFleet": 145125,
        "sealedUnit": 0,
        "sealedFleet": 0,
        "displayValue": "0.00_145,125_0.00_0"
    },
    {
        "standardUnit": 290.25,
        "standardFleet": 290250,
        "sealedUnit": 74.18,
        "sealedFleet": 74185.30,
        "displayValue": "290.25_290,250_74.19_74,185"
    },
    {
        "standardUnit": 35,
        "standardFleet": 35000,
        "sealedUnit": 0,
        "sealedFleet": 0,
        "displayValue": "35.00_35,000_0.00_0"
    },
    {
        "standardUnit": 70,
        "standardFleet": 70000,
        "sealedUnit": 17.89,
        "sealedFleet": 17891.37,
        "displayValue": "70.00_70,000_17.89_17,891"
    },
    {
        "standardUnit": 540.375,
        "standardFleet": 540375,
        "sealedUnit": 367.07,
        "sealedFleet": 367076.67,
        "displayValue": "540.38_540,375_367.08_367,077"
    },
    {
      "TcoStandard": 270.19,
      "TcoSealed":183.54,
      "NetSavings": 173298,
      "displayValue": "270.19,183.54,173298"
  }
]

  toolTipData$ =  new BehaviorSubject<any[]>([]);
  currentComponent$=new BehaviorSubject<any>(null);
  valueDisclaimer$=new BehaviorSubject<any>(false);

  vistInfoData$=new BehaviorSubject<any>(this.defaultvistInfo);
  fleetInfoData$=new BehaviorSubject<any>(this.defaultFleetInfo);
  replacementData$=new BehaviorSubject<any>(this.defaultreplacement);
  currentProdData$=new BehaviorSubject<any>(this.defaultrecurrentProduct);
  csaData$=new BehaviorSubject<any>(this.defaultCsa);
  upchargeData$=new BehaviorSubject<any>(this.defaultPro);

  summaryData=new BehaviorSubject<any[]>(this.defaultData);
  summaryData$=this.summaryData.asObservable();
  popUpData$=new BehaviorSubject<any>(this.popUpData);

  resetForms$=new BehaviorSubject<any>(null);


   brandData = {
    "Bendix EnduraSure": 4.36,
    "Bendix EnduraSure-Pro": 8.00,
    "Haldex Gold Seal": 1.45,
    "Haldex Life Seal": 5.45,
    "TSE Omni": 2.55,
    "TSE Ultra": 3.49,
    "WABCO Tristop": 1.60,
    "Other": 1.45 // A default value if no match is found
  }
  fleetSizeTractors: any;
  tractorTradeInCycle: any;
  fleetSizeTrailers: any;
  trailerTradeInCycle: any;
  totalCostPerFailedActuator: any;
  numberOfActuatorsReplacedPerYear: any;
  brandOfActuator: any;
  roadsideCallRate: any;
  annualRoadsideCallsToActuators: any;
  roadsideCallRateCsaViolation: any;
  annualOutOfServiceCsaViolations: any;
  estimatedUpchargeForTractor: any;
  estimatedUpchargeForTrailer: any;
  currentLife: any;
  actuatorsForTractorsPastExpectedLife: any;
  actuatorsForTrailersPastExpectedLife: any;
  totalOutOfWarranty: any;
  failureOccurrencePerUnitOutOfWarranty: any;
  endurasureProLife: number;
  TractorsOutOfWarrantySealed: number;
  TrailersOutOfWarrantySealed: number;
  TotalOutOfWarrantySealed: any;
  NumberOfActuatorsReplacedIn1YearSealed: number;
  AnnualMaintenanceCostTotalSealed: number;
  AnnualMaintenanceCostPerUnitTractor: number;
  AnnualMaintenanceCostPerUnitTrailer: number;
  LifetimeMaintenancePerTractor: number;
  LifetimeMaintenancePerTrailer: number;
  reductionOfFailureRelatedCosts: number;
  totalAnnualCSACosts: number;
  annualCSACostPerUnitTractor: number;
  annualCSACostPerUnitTrailers: number;
  lifetimeCSACostPerTractor: number;
  lifetimeCSACostPerTrailer: number;
  totalCostToChangeoverTractors: number;
  totalCostToChangeoverTrailers: number;
  annualMaintenanceCost: number;
  annualPerUnitCost: number;
  lifetimeTractorCost: number;
  lifetimeTrailerCost: number;
  totalCSARelatedCostsPerYear: number;
  csaAnnualPerUnitCost: number;
  csaLifetimeTractorCost: number;
  csaLifetimeTrailerCost: number;
  standardUnitTractor: number;
  standardFleetTractor: number;
  sealedUnitTractor: any;
  sealedFleetTractor: number;
  row1: string;
  standardUnitTrailer: number;
  standardTotalTrailer: number;
  sealedUnitTrailer: any;
  sealedFleetTrailer: number;
  row2: string;
  standardUnitLifeTractor: number;
  standardTotalLifeTractor: number;
  sealedUnitLifeTractor: any;
  sealedFleetLifeTractor: number;
  row3: string;
  standardUnitLifeTrailer: number;
  standardFleetLifeTrailer: number;
  sealedUnitLifeTrailer: any;
  sealedFleetLifeTrailer: number;
  row4: string;
  standardUnitCsaTractor: number;
  standardFleetCsaTractor: number;
  sealedUnitCsaTractor: any;
  sealedFleetCsaTractor: number;
  row5: string;
  standardUnitCsaTrailer: number;
  standardFleetCsaTrailer: number;
  sealedUnitCsaTrailer: any;
  sealedFleetCsaTrailer: number;
  row6: string;
  standardUnitTotal: any;
  standardFleetTotal: any;
  sealedUnitTotal: any;
  sealedFleetTotal: any;
  row7: string;
  TcoStandard: number;
  TcoSealed: number;
  netSavingText: any;
  NetSavings: any;
  roi: string;
  fn: any;
  p_firstName: any;
  p_lastName: any;
  p_eMail: any;
  p_valueDisclaimer: any;
  fn2: any;
  fn3: any;
  fn4: any;
  f5: any;
  fn6: any[];
  fn7: any;
  payload: any;
res:Observable<any>;
  constructor(private matdialog: MatDialog,
    private http: HttpClient, private occService: OccEndpointsService,private translationService:TranslationService) {}

  // forToolTip
  openTootlip(tittle,content,content1?){
    this.toolTipData$.next([tittle,content,content1])
    this.matdialog.open(EndasureTooltipPopUPComponent)
  }
  //GetAPI
  getbrandOfActuator(){
    return this.http.get(this.occService.buildUrl(`enduraSurePro/getdropdown`));
  }
TableCalculation(){

this.fleetInfoData$?.subscribe(data=>{
  this.fleetSizeTractors=data?.fleetSizeTractors; //E5
  this.tractorTradeInCycle=data?.tractorTradeInCycle;  //E6
  this.fleetSizeTrailers= data?.fleetSizeTrailers;     //E7
  this.trailerTradeInCycle=data?.trailerTradeInCycle;      //E8
});

this.replacementData$?.subscribe(data=>{
  this.totalCostPerFailedActuator=data?.totalCostPerFailedActuator;       //E12
  this.numberOfActuatorsReplacedPerYear= data?.numberOfActuatorsReplacedPerYear;//E13
})

this.currentProdData$?.subscribe(data=>{
  this.brandOfActuator=data?.brandOfActuator;       //E12

})

this.csaData$?.subscribe(data=>{
  this.roadsideCallRate=data?.roadsideCallRate;//E17
  this.annualRoadsideCallsToActuators=data?.annualRoadsideCallsToActuators;//E18
  this.roadsideCallRateCsaViolation=data?.roadsideCallRateCsaViolation;//E19
  this.annualOutOfServiceCsaViolations=data?.annualOutOfServiceCsaViolations;//E20
})

this.upchargeData$?.subscribe(data=>{
  this.estimatedUpchargeForTractor=data?.estUpchargeForEndTractor;//E23
  this.estimatedUpchargeForTrailer=data?.estUpchargeForEndTrailer;//E24
})

//Annual Replacement Cost / Actuator Calculation
this.annualMaintenanceCost = (this.totalCostPerFailedActuator*this.numberOfActuatorsReplacedPerYear);
this.annualPerUnitCost     = this.annualMaintenanceCost/(this.fleetSizeTractors+this.fleetSizeTrailers);
this.lifetimeTractorCost   = this.annualPerUnitCost*this.tractorTradeInCycle;
this.lifetimeTrailerCost   = this.annualPerUnitCost*this.trailerTradeInCycle;
//alert("Step-1: "+annualMaintenanceCost+","+annualPerUnitCost+","+lifetimeTractorCost+","+lifetimeTrailerCost)


//CSA Downtime Cost calculation
this.totalCSARelatedCostsPerYear	= (this.roadsideCallRate*this.annualRoadsideCallsToActuators+this.roadsideCallRateCsaViolation*this.annualOutOfServiceCsaViolations);
this.csaAnnualPerUnitCost 		= this.totalCSARelatedCostsPerYear/(this.fleetSizeTractors+this.fleetSizeTrailers);
this.csaLifetimeTractorCost 		= this.csaAnnualPerUnitCost*this.tractorTradeInCycle;
this.csaLifetimeTrailerCost 		= this.csaAnnualPerUnitCost*this.trailerTradeInCycle;
//alert("Step-2: "+totalCSARelatedCostsPerYear+","+csaAnnualPerUnitCost+","+csaLifetimeTractorCost+","+csaLifetimeTrailerCost)

this.currentLife = this.brandData[this.brandOfActuator];   //E36

 //alert("step-3:"+this.currentLife);

this.actuatorsForTractorsPastExpectedLife=((1-this.currentLife/this.tractorTradeInCycle)*this.fleetSizeTractors); //E37
//alert("step-4:"+this.actuatorsForTractorsPastExpectedLife)


this.actuatorsForTrailersPastExpectedLife=((1-this.currentLife/this.trailerTradeInCycle)*this.fleetSizeTrailers); //E38
//alert("step-5:"+this.actuatorsForTrailersPastExpectedLife)



this.totalOutOfWarranty=(this.actuatorsForTractorsPastExpectedLife+this.actuatorsForTrailersPastExpectedLife); //E39
//alert("step-6:"+this.totalOutOfWarranty);



this.failureOccurrencePerUnitOutOfWarranty=(this.numberOfActuatorsReplacedPerYear/this.totalOutOfWarranty); //E40  // Convert the float to a percentage if needed
//alert("step-7:"+this.failureOccurrencePerUnitOutOfWarranty);


//EndurasureProLife Default value
this.endurasureProLife=8; //Default value E42
this.TractorsOutOfWarrantySealed = (this.endurasureProLife > this.tractorTradeInCycle) ? 0 : ((1 - this.endurasureProLife / this.tractorTradeInCycle) * this.fleetSizeTractors);
this.TrailersOutOfWarrantySealed = (this.endurasureProLife > this.trailerTradeInCycle) ? 0 : ((1 - this.endurasureProLife / this.trailerTradeInCycle) * this.fleetSizeTrailers);
this.TotalOutOfWarrantySealed=(this.TractorsOutOfWarrantySealed + this.TrailersOutOfWarrantySealed);

//alert("step:8-"+" "+endurasureProLife+" "+TractorsOutOfWarrantySealed+" "+TrailersOutOfWarrantySealed+" "+ TotalOutOfWarrantySealed)


this.NumberOfActuatorsReplacedIn1YearSealed=(this.failureOccurrencePerUnitOutOfWarranty*this.TotalOutOfWarrantySealed);
this.AnnualMaintenanceCostTotalSealed=(this.NumberOfActuatorsReplacedIn1YearSealed*this.totalCostPerFailedActuator);
this.AnnualMaintenanceCostPerUnitTractor = (this.TractorsOutOfWarrantySealed === 0) ? 0 : ((this.TractorsOutOfWarrantySealed / this.TotalOutOfWarrantySealed) * this.AnnualMaintenanceCostTotalSealed / this.fleetSizeTractors);
this.AnnualMaintenanceCostPerUnitTrailer = (this.TrailersOutOfWarrantySealed === 0) ? 0 : ((this.TrailersOutOfWarrantySealed / this.TotalOutOfWarrantySealed) * this.AnnualMaintenanceCostTotalSealed / this.fleetSizeTrailers);
this.LifetimeMaintenancePerTractor=this.AnnualMaintenanceCostPerUnitTractor*this.tractorTradeInCycle; //E51
this.LifetimeMaintenancePerTrailer=this.AnnualMaintenanceCostPerUnitTrailer*this.trailerTradeInCycle; //E52

//alert("step:9-"+" "+NumberOfActuatorsReplacedIn1YearSealed+" "+AnnualMaintenanceCostTotalSealed+" "+AnnualMaintenanceCostPerUnitTractor+" "+ AnnualMaintenanceCostPerUnitTrailer+" "+ LifetimeMaintenancePerTractor+" "+ LifetimeMaintenancePerTrailer)


//reductionOfFailureRelatedCosts
this.reductionOfFailureRelatedCosts=1-this.AnnualMaintenanceCostTotalSealed/this.annualMaintenanceCost;
this.totalAnnualCSACosts=this.totalCSARelatedCostsPerYear*(1-this.reductionOfFailureRelatedCosts);
this.annualCSACostPerUnitTractor=(this.TractorsOutOfWarrantySealed=== 0 )? 0 :((this.TractorsOutOfWarrantySealed/this.TotalOutOfWarrantySealed)*this.totalAnnualCSACosts/this.fleetSizeTractors);
this.annualCSACostPerUnitTrailers=(this.TrailersOutOfWarrantySealed=== 0 )? 0 :((this.TrailersOutOfWarrantySealed/this.TotalOutOfWarrantySealed)*this.totalAnnualCSACosts/this.fleetSizeTrailers);
this.lifetimeCSACostPerTractor=this.annualCSACostPerUnitTractor*this.tractorTradeInCycle; //E58
this.lifetimeCSACostPerTrailer=this.annualCSACostPerUnitTrailers*this.trailerTradeInCycle; //E59
//alert("step:17-"+" "+reductionOfFailureRelatedCosts+" "+totalAnnualCSACosts+" "+annualCSACostPerUnitTractor+" "+ annualCSACostPerUnitTrailers+" "+ lifetimeCSACostPerTractor+" "+ lifetimeCSACostPerTrailer)

//Upcharge on New Equipment

this.totalCostToChangeoverTractors=this.estimatedUpchargeForTractor*this.fleetSizeTractors;
this.totalCostToChangeoverTrailers=this.estimatedUpchargeForTrailer*this.fleetSizeTrailers;
//alert("step:18-"+" "+totalCostToChangeoverTractors+" "+totalCostToChangeoverTrailers)


 //row1
 this.standardUnitTractor =0;
 this.standardFleetTractor = this.standardUnitTractor*this.fleetSizeTractors;
 this.sealedUnitTractor=this.estimatedUpchargeForTractor;
 this.sealedFleetTractor=(this.sealedUnitTractor*this.fleetSizeTractors);
 const row1 = this.createRowData( this.standardUnitTractor, this.standardFleetTractor,
  this.sealedUnitTractor, this.sealedFleetTractor);
 this.updateRow(0, row1);
 //alert("Row1-"+this.row1);

 //row2
 this.standardUnitTrailer =0;
 this.standardTotalTrailer = this.standardUnitTrailer*this.fleetSizeTrailers;
 this.sealedUnitTrailer= this.estimatedUpchargeForTrailer;
 this.sealedFleetTrailer=this.sealedUnitTrailer*this.fleetSizeTrailers;

 const row2 = this.createRowData( this.standardUnitTrailer, this.standardTotalTrailer,
  this.sealedUnitTrailer, this.sealedFleetTrailer);
 this.updateRow(1, row2);
 //alert("Row2-"+this.row2);


  //row3
  this.standardUnitLifeTractor = ((this.totalCostPerFailedActuator*this.numberOfActuatorsReplacedPerYear)/(this.fleetSizeTractors+this.fleetSizeTrailers))*this.tractorTradeInCycle;
  this.standardTotalLifeTractor = this.standardUnitLifeTractor*this.fleetSizeTractors;
  this.sealedUnitLifeTractor=this.LifetimeMaintenancePerTractor;
  this.sealedFleetLifeTractor=this.sealedUnitLifeTractor*this.fleetSizeTractors;
  const row3 = this.createRowData(
    this.standardUnitLifeTractor, this.standardTotalLifeTractor,
    this.sealedUnitLifeTractor, this.sealedFleetLifeTractor);
   this.updateRow(2, row3);


  //alert("Row3-"+this.row3);

  //row 4
  this.standardUnitLifeTrailer=((this.totalCostPerFailedActuator*this.numberOfActuatorsReplacedPerYear)/(this.fleetSizeTractors+this.fleetSizeTrailers))*this.trailerTradeInCycle;
  this.standardFleetLifeTrailer=this.standardUnitLifeTrailer*this.fleetSizeTrailers;
  this.sealedUnitLifeTrailer=this.LifetimeMaintenancePerTrailer;
  this.sealedFleetLifeTrailer=this.sealedUnitLifeTrailer*this.fleetSizeTrailers;


  const row4 = this.createRowData(
    this.standardUnitLifeTrailer, this.standardFleetLifeTrailer,
    this.sealedUnitLifeTrailer, this.sealedFleetLifeTrailer);
   this.updateRow(3, row4);

 //alert("Row4-"+this.row4);

  //row 5
  this.standardUnitCsaTractor = ((this.roadsideCallRate*this.annualRoadsideCallsToActuators+this.roadsideCallRateCsaViolation*this.annualOutOfServiceCsaViolations)/(this.fleetSizeTractors+this.fleetSizeTrailers))*this.tractorTradeInCycle;
  this.standardFleetCsaTractor =this.standardUnitCsaTractor*this.fleetSizeTractors;
  this.sealedUnitCsaTractor= this.lifetimeCSACostPerTractor;
  this.sealedFleetCsaTractor =this.sealedUnitCsaTractor*this.fleetSizeTractors;

  const row5 = this.createRowData(
    this.standardUnitCsaTractor, this.standardFleetCsaTractor,
    this.sealedUnitCsaTractor, this.sealedFleetCsaTractor);
   this.updateRow(4, row5);

  //alert("Row5-"+this.row5);

   //row 6
  this.standardUnitCsaTrailer = ((this.roadsideCallRate*this.annualRoadsideCallsToActuators+this.roadsideCallRateCsaViolation*this.annualOutOfServiceCsaViolations)/(this.fleetSizeTractors+this.fleetSizeTrailers))*this.trailerTradeInCycle;
  this.standardFleetCsaTrailer =this.standardUnitCsaTrailer*this.fleetSizeTrailers;
  this.sealedUnitCsaTrailer= this.lifetimeCSACostPerTrailer;
  this.sealedFleetCsaTrailer =this.sealedUnitCsaTrailer*this.fleetSizeTrailers;

  const row6 = this.createRowData(
    this.standardUnitCsaTrailer, this.standardFleetCsaTrailer,
    this.sealedUnitCsaTrailer, this.sealedFleetCsaTrailer);
   this.updateRow(5, row6);
  //alert("Row6-"+this.row6);


  //row 7
  this.standardUnitTotal =this.standardUnitTractor+this.standardUnitTrailer+this.standardUnitLifeTractor+this.standardUnitLifeTrailer+this.standardUnitCsaTractor+this.standardUnitCsaTrailer;
  this.standardFleetTotal =this.standardFleetTractor+this.standardTotalTrailer+this.standardTotalLifeTractor+this.standardFleetLifeTrailer+this.standardFleetCsaTractor+this.standardFleetCsaTrailer;
  this.sealedUnitTotal =this.sealedUnitTractor+this.sealedUnitTrailer+this.sealedUnitLifeTractor+this.sealedUnitLifeTrailer+this.sealedUnitCsaTractor+this.sealedUnitCsaTrailer;
  this.sealedFleetTotal =this.sealedFleetTractor+this.sealedFleetTrailer+this.sealedFleetLifeTractor+this.sealedFleetLifeTrailer+this.sealedFleetCsaTractor+this.sealedFleetCsaTrailer;


  const row7 = this.createRowData(
    this.standardUnitTotal, this.standardFleetTotal,
    this.sealedUnitTotal, this.sealedFleetTotal);
   this.updateRow(6, row7);
 //alert("Row7-"+this.row7);


  //ROI table
   this.TcoStandard= this.standardFleetTotal/(this.fleetSizeTractors+this.fleetSizeTrailers);
   this.TcoSealed=this.sealedFleetTotal/(this.fleetSizeTractors+this.fleetSizeTrailers);
   this.translationService.translate('common.value_cal_negativeVal_text').subscribe(x=>{
      this.netSavingText=x;
   });

   this.NetSavings=((this.standardFleetTotal-this.sealedFleetTotal)>0 ) ? this.standardFleetTotal-this.sealedFleetTotal:this.netSavingText;
  const row8 = this.createRoiRowData(
    this.TcoStandard, this.TcoSealed,
    this.NetSavings);
   this.updateRow(7, row8);
  //alert("Roi-"+this.roi);


}


createRowData(standardUnit: number, standardFleet: number, sealedUnit: any, sealedFleet: number) {
  const displayValue = `${standardUnit.toFixed(2)}_${Math.round(standardFleet).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}_${sealedUnit.toFixed(2)}_${Math.round(sealedFleet).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}`;
  return {
    standardUnit,
    standardFleet,
    sealedUnit,
    sealedFleet,
    displayValue
  };
}

createRoiRowData(TcoStandard: number, TcoSealed: number, NetSavings: any) {
  const displayValue = `${TcoStandard.toFixed(2)}_${TcoSealed.toFixed(2)}_${Math.round(NetSavings).toLocaleString('en-US', { style: 'decimal', maximumFractionDigits: 0 })}}`;
  return {
    TcoStandard,
    TcoSealed,
    NetSavings,
    displayValue
  };
}

updateRow(index, rowData): void {

    const currentData = this.summaryData.value;
    if (index >= 0&& index < currentData.length) {
      currentData[index] = rowData;
      this.summaryData.next([...currentData]);
    }

}

getCurrentData() {
  return this.summaryData.value;
}

triggerReset(){
  this.vistInfoData$.next(this.defaultvistInfo);
  this.fleetInfoData$.next(this.defaultFleetInfo);
  this.replacementData$.next(this.defaultreplacement);
  this.currentProdData$.next(this.defaultrecurrentProduct);
  this.csaData$.next(this.defaultCsa);
  this.upchargeData$.next(this.defaultPro);
  this.summaryData.next(this.defaultData);
}

postAPI(){
  return this.http.post(this.occService.buildUrl('enduraSurePro/sentemail'),this.createPayload(),{ responseType: 'text' });

}
createPayload(){
  this.payload = {
    eMail: '',
    firstName: '',
    lastName: '',
    valueDisclaimer: '',
    fleetSizeTractors: '',
    tractorTradeInCycle: '',
    fleetSizeTrailers: '',
    trailerTradeInCycle: '',
    replacementFleetCostPerActuator: '',
    laborToInstallActuator: '',
    totalCostPerFailedActuator: '',
    numberOfActuatorsReplacedPerYear: '',
    currentComponent: '',
    roadsideCallRate: '',
    annualRoadsideCallsToActuators: '',
    roadsideCallRateCsaViolation: '',
    annualOutOfServiceCsaViolations: '',
    fleetDowntimeRate: '',
    estUpchargeForEndTractor: '',
    estUpchargeForEndTrailer: '',
    displayValue1: '',
    displayValue2: '',
    displayValue3: '',
    displayValue4: '',
    displayValue5: '',
    displayValue6: '',
    displayValue7: '',
    total:'',
    netFleetSavings:'',
    tcoPerUnitStandard: '',
    TcoSealed: '',
    FName: '',
    LName: '',
    emailId: ''
};
  this.vistInfoData$.subscribe((x:any) => {
    this.payload.eMail = x?.eMail ;
    this.payload.firstName = x?.firstName ;
    this.payload.lastName = x?.lastName ;
    this.payload.valueDisclaimer = x?.valueDisclaimer ;

  });

  this.fleetInfoData$.subscribe((x:any) => {
    this.payload.fleetSizeTractors = x?.fleetSizeTractors ;
    this.payload.tractorTradeInCycle = x?.tractorTradeInCycle ;
    this.payload.fleetSizeTrailers = x?.fleetSizeTrailers ;
    this.payload.trailerTradeInCycle = x?.trailerTradeInCycle ;
  });

  this.replacementData$.subscribe((x:any) => {
    this.payload.replacementFleetCostPerActuator = x?.replacementFleetCostPerActuator ;
    this.payload.laborToInstallActuator = x?.laborToInstallActuator ;
    this.payload.totalCostPerFailedActuator = x?.totalCostPerFailedActuator ;
    this.payload.numberOfActuatorsReplacedPerYear = x?.numberOfActuatorsReplacedPerYear ;
  });

  this.currentComponent$.subscribe((x:any) => {
    this.payload.currentComponent = x ;
  });

  this.csaData$.subscribe((x:any) => {
    this.payload.roadsideCallRate = x?.roadsideCallRate ;
    this.payload.annualRoadsideCallsToActuators = x?.annualRoadsideCallsToActuators ;
    this.payload.roadsideCallRateCsaViolation = x?.roadsideCallRateCsaViolation ;
    this.payload.annualOutOfServiceCsaViolations = x?.annualOutOfServiceCsaViolations ;
    this.payload.fleetDowntimeRate = x?.fleetDowntimeRate ;
  });

  this.upchargeData$.subscribe((x:any) => {
    this.payload.estUpchargeForEndTractor = x?.estUpchargeForEndTractor ;
    this.payload.estUpchargeForEndTrailer = x?.estUpchargeForEndTrailer ;
  });

  this.summaryData$.subscribe((x:any) => {
    this.payload.displayValue1 = x[0]?.displayValue ;
    this.payload.displayValue2 = x[1]?.displayValue ;
    this.payload.displayValue3 = x[2]?.displayValue ;
    this.payload.displayValue4 = x[3]?.displayValue ;
    this.payload.displayValue5 = x[4]?.displayValue ;
    this.payload.displayValue6 = x[5]?.displayValue ;
    this.payload.displayValue7 = x[6]?.displayValue ;
    this.payload.displayValue8 = x[7]?.displayValue ;
    this.payload.tcoPerUnitStandard= x[7]?.TcoStandard ;
    this.payload.TcoSealed= x[7]?.TcoSealed ;
    this.payload.netFleetSavings=x[7]?.netFleetSavings ;
  });

  this.popUpData$.subscribe((x:any) => {
    this.payload.FName = x?.FName ;
    this.payload.LName = x?.LName ;
    this.payload.emailId = x?.emailId ;
  });

const payload=
{
firstName:this.payload?.firstName,
lastName:this.payload?.lastName,
companyEmail:  this.payload?.eMail,
disclaimer: this.payload?.valueDisclaimer,

fleetSizeTractors:  this.payload?.fleetSizeTractors,
tractorTradeInCycle: this.payload?.tractorTradeInCycle,
fleetSizeTrailers: this.payload?.fleetSizeTrailers,
trailerTradeInCycle: this.payload?.trailerTradeInCycle,

replacementFleetCostPerActuator: this.payload?.replacementFleetCostPerActuator,
laborToInstallActuator: this.payload?.laborToInstallActuator,
totalCostPerFailedActuator: this.payload?.totalCostPerFailedActuator,
numberOfActuatorsReplacedPerYear: this.payload?.numberOfActuatorsReplacedPerYear,

brandOfActuator: this.payload?.brandOfActuator,

roadsideCallRate:this.payload?.roadsideCallRate,
annualRoadsideCallsToActuators: this.payload?.annualRoadsideCallsToActuators,
roadsideCallRateCsaViolation: this.payload?.roadsideCallRateCsaViolation,
annualOutOfServiceCsaViolations: this.payload?.annualOutOfServiceCsaViolations,
fleetDowntimeRate: this.payload?.fleetDowntimeRate,
estUpchargeForEndTractor: this.payload?.estUpchargeForEndTractor,
estUpchargeForEndTrailer: this.payload?.estUpchargeForEndTrailer,

initialPurchaseCostTractor: this.payload?.displayValue1,
initialPurchaseCostTrailor:this.payload?.displayValue2,
lifetimeReplacementCostsTractor: this.payload?.displayValue3,
lifetimeReplacementCostsTrailor: this.payload?.displayValue4,
csaRelatedCostsTractor: this.payload?.displayValue5,
csaRelatedCostsTrailor: this.payload?.displayValue6,
total: this.payload?.displayValue7,

tcoPerUnitStandard: this.payload?.tcoPerUnitStandard,
tcoPerUnitSealed: this.payload?.TcoSealed,
netFleetSavings: this.payload?.netFleetSavings,

FName: this.payload?.FName,
LName: this.payload?.LName,
emailId: this.payload?.emailId,
bypassRecaptchaEmailDomain: false
}

return payload;
}

}









